import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './components/app.js'
import './styles.css'

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./app/main.js